<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">Create User</h4>
                <p class="text-subtitle-1">User Form</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <UserForm 
                    ref="form"
                    v-model="data"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn 
                    color="primary"
                    block
                    @click="handleSubmit"
                >
                    save
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn
                    depressed
                    block
                    @click="handleCancel"
                >
                    cancel
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
    </div>
</template>

<script>
import user from "./../../services/administration/user"
import PAlert from "./../../components/common/PAlert.vue"
import UserForm from './../../components/administration/UserForm'
import { mapActions } from 'vuex'
export default {
    components: {
        UserForm,
        PAlert
    },
    data() {
        return {
            data: {},
            alert:{
                title: "Alert",
                value: false,
                content: "",
                callback: null
            },
            loading: false
        }
    },
    methods: {
        ...mapActions({
           snackbar: "ui/snackbar/show"
        }),
        validate() {
            this.$refs.form.validate()
        },
        handleSubmit() {
            this.alert = {
                ...this.alert ,
                value: true,
                content: "Are you sure you want to save?",
                callback: this.submit
            }
        },
        submit() {
            if(!this.$refs.form.validate()) return;
            this.loading = true
            user.create(this.data).then(response => {
                if(response.data?.record?.id){
                    this.snackbar({
                        text: response.data.message,
                        color: "success"
                        })     
                    this.$router.replace({ name: "UserDisplay", params: {id : response.data.record.id}})
                }else{
                    let text = Object.values(response.data).join()
                    this.snackbar({
                        text,
                        color: "error"
                    })
                }       
            })
            .finally(() => {
                this.loading = false
            })
        },         
        handleCancel() {
            this.alert = {
                ...this.alert,
                value: true,
                content: "Are you sure you want to cancel?",
                callback: this.cancel   
            }
        },
        cancel() {
            this.$router.back()
        }
    }
}
</script>

<style>

</style>